import React, { useRef, useEffect } from 'react';
import { styled } from 'styled-components';

const SpotlightContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 10;
  background: radial-gradient(circle at 50% 50%, transparent 0%, rgba(0, 0, 0, 0.4) 60%);
  transition: background 0.1s ease-out;
  mix-blend-mode: multiply;
`;

const GlowOrb = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    rgba(0, 255, 136, 0.3) 0%,
    rgba(0, 255, 136, 0.1) 40%,
    transparent 70%
  );
  filter: blur(20px);
  transform: translate(-50%, -50%);
  transition: all 0.2s ease-out;
  z-index: 11;
`;

const SpotlightEffect: React.FC = () => {
  const spotlightRef = useRef<HTMLDivElement>(null);
  const orbRef = useRef<HTMLDivElement>(null);
  const mousePos = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
      
      if (spotlightRef.current) {
        spotlightRef.current.style.background = `radial-gradient(circle at ${e.clientX}px ${e.clientY}px, transparent 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.6) 80%)`;
      }
      
      if (orbRef.current) {
        orbRef.current.style.left = `${e.clientX}px`;
        orbRef.current.style.top = `${e.clientY}px`;
      }
    };

    const handleMouseLeave = () => {
      if (spotlightRef.current) {
        spotlightRef.current.style.background = `radial-gradient(circle at 50% 50%, transparent 0%, rgba(0, 0, 0, 0.2) 60%)`;
      }
    };

    // Smooth animation loop for subtle movement
    const animate = () => {
      if (orbRef.current) {
        const time = Date.now() * 0.002;
        const offsetX = Math.sin(time) * 3;
        const offsetY = Math.cos(time * 1.3) * 2;
        
        orbRef.current.style.transform = `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px))`;
      }
      requestAnimationFrame(animate);
    };
    animate();

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <>
      <SpotlightContainer ref={spotlightRef} />
      <GlowOrb ref={orbRef} />
    </>
  );
};

export default SpotlightEffect;